@if (facility$ | async; as facility) {
<div class="overview">
  <div class="header">
    <span class="facility-name">{{ facility.name }}</span>
    <span>
      <button class="iconf-btn-blank minw150" (click)="editFacility(facility)">
        <mat-icon class="mat-icon-blue">edit</mat-icon>
        edit facility
      </button>
      <button class="iconf-btn-blank minw150" (click)="deleteFacility(facility)">
        <mat-icon class="mat-icon-blue">delete</mat-icon>
        delete facility
      </button>
    </span>
  </div>
  <app-facility-overview [facility]="facility"> </app-facility-overview>
</div>
<app-separator></app-separator>
<div>
  @if (facility.numSystems > 0) {
  <div class="systems-header">
    <span>systems ({{ facility.numSystems }})</span>
    <button class="iconf-btn-blank" (click)="navigateToSystemSelection()">
      <mat-icon>add_circle</mat-icon>
      add/remove systems
    </button>
  </div>
  } @if (facility.numSystems == 0) {
  <app-placeholder
    [icon]="noSystemsIcon"
    title="No systems added yet"
    description="Add and configure the systems of your facility"
    buttonCaption="add systems"
    class="placeholder"
    (buttonClick)="navigateToSystemSelection()"
  >
  </app-placeholder>
  } @if (facility.numSystems > 0) {
  <app-status-filter
    class="status-filter"
    [filterTabsCount]="systems$ | async | StatusFilterCount"
    [filterTabs]="['all', 'not started', 'in progress', 'completed']"
  ></app-status-filter>
  <app-system-table
    class="systems-table"
    [systems]="systems$ | async | EntityFilter : filterModels | async"
    (systemSelected)="onSystemsSelected($event)"
  ></app-system-table>
  @if (selectedSystems.length > 0) {
  <button
    class="iconf-btn-filled minw150 config-selected"
    [routerLink]="
      selectedSystems[0].status == 'completed'
        ? ['system', selectedSystems[0].id, 'recommendation']
        : ['system', selectedSystems[0].id, 'questionnaire']
    "
    [queryParams]="{ systems: selectedSystemIds }"
    queryParamsHandling="merge"
  >
    configure selected
  </button>
  } }
</div>
}
